<template>
  <div class="layInfo">
    <div class="content-bg">
      <div class="left-box">
        <img src="@/assets/icon-user.png" class="icon" alt="" />
        <div class="name">{{ userModel.name }}</div>
        <div class="time">{{ userModel.time }}</div>
        <slot name="collection"></slot>
      </div>
      <div class="right-box-bg">
        <div class="right-box">
          <div
            class="long"
            @click="longDo"
            :style="{ color: longColor, backgroundColor: longBgColor }"
          >
            LongLived
          </div>
          <div
            class="short"
            @click="shortDo"
            :style="{ color: shortColor, backgroundColor: shortBgColor }"
          >
            ShortLived
          </div>
        </div>
        <!-- 插槽 -->
        <slot name="publish"></slot>
      </div>
    </div>
    <UniversalPopover :dialogVisible="showVisible" :title="title" :brightTitle="brightTitle" @cancelDo="cancelDo"
        @comfirmDo="comfirmDo"></UniversalPopover>
  </div>
</template>
<script>
import UniversalPopover from "@/components/UniversalPopover.vue";
export default {
  name: "layInfo",
  props: {
    userModel: {
      type: Object,
      default: () => {},
    },
    isCanEdite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showVisible: false,
      title: "are you sure to change it to",
      brightTitle: "LongLived",
      isLong: true,
    };
  },
  computed: {
    longColor() {
      return this.userModel.type == 1 ? "#ffffff" : "#A6A6A6";
    },
    longBgColor() {
      return this.userModel.type == 1 ? "#0052D9" : "#F5F5F5";
    },
    shortColor() {
      return this.userModel.type == 0 ? "#ffffff" : "#A6A6A6";
    },
    shortBgColor() {
      return this.userModel.type == 0 ? "#0052D9" : "#F5F5F5";
    },
  },
  methods: {
    cancelDo() {
      this.showVisible = false;
    },
    comfirmDo() {
      if (this.userModel.type == 0) {
        this.$emit("longDo");
      } else if (this.userModel.type == 1) {
        this.$emit("shortDo");
      }
      this.cancelDo()
    },
    longDo() {
      if (!this.isCanEdite) {
        return;
      }
      if (this.userModel.type == 0) {
        this.brightTitle = "LongLived"
        this.showVisible = true;
      }
    },
    shortDo() {
      if (!this.isCanEdite) {
        return;
      }
      if (this.userModel.type == 1) {
        this.brightTitle = "ShortLived"
        this.showVisible = true;
      }
    },
  },
  created() {},
  components: {
    UniversalPopover
  }
};
</script>
<style lang='less' scoped>
.layInfo {
  background-color: #f5f5f5;
  width: 100%;
}

.content-bg {
  margin-top: 30px;
  width: 100%;
  margin: 0 auto;

  // .top-box {
  display: flex;
  flex-direction: row;
  height: 90px;
  background-color: #fff;
  align-items: center;
  justify-content: space-between;
  margin-top: 60px;
  // margin-right: 50px;
  // margin: 0px 60px 0px 60px;
  padding: 0px 30px;
  .left-box {
    display: flex;
    align-items: center;
    img {
      height: 40px;
      width: 40px;
    }

    .name {
      margin-left: 20px;
    }

    .time {
      margin-left: 50px;
    }
  }

  .right-box-bg {
    display: flex;
    align-items: center;
  }

  .right-box {
    display: flex;
    background-color: #f5f5f5;
    height: 36px;
    align-items: center;
    border-radius: 15px;

    .long {
      background-color: #0052d9;
      padding: 5px 15px;
      font-size: 16px;
      border-radius: 15px;
      color: #fff;
      cursor: pointer;
    }
    .short {
      background-color: #f5f5f5;
      padding: 5px 15px;
      font-size: 16px;
      border-radius: 15px;
      color: #fff;
      cursor: pointer;
    }
  }
  // }
}
</style>